import { Component, OnDestroy, OnInit, Input, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { RiderService, ConfigService, XpressUserService, SignalrService } from 'app/services';
import { Utils } from 'app/utils';
import * as moment from 'moment';
import {
    LastActiveTypeModel, BackOfficeEnum, RiderVehicleTypeEnum,
    ServiceTypeEnum, RiderSourceTypeEnum, RiderSourceType, XpressRiderStatus, FieldTypeEnum
} from 'app/models';
import { Observable, Subscription } from 'rxjs';
import { AppComponent } from 'app/app.component';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'drivers-draft',
    templateUrl: './drivers-draft.component.html',
    styleUrls: ['./drivers-draft.component.scss',
        '../../../../../styles/paginator.scss'],
    providers: [MessageService]
})
export class DriversDraftComponent implements OnInit, OnDestroy {
    @Input()
    public menuPermissionActive!: string;

    public backOfficeActive!: BackOfficeEnum;
    public fieldTypeEnum = FieldTypeEnum;
    public tableName: string = '';
    @Input()
    set _backOfficeActive(value: BackOfficeEnum) {
        this.backOfficeActive = value;
        this.callBackOfficeForFilter(this.backOfficeActive);
        if (this.backOfficeActive && !this.lazyLoadHandled) {
            this.driverHeaderSearch = [];
            this.handleLazyLoad({
                first: 0,
                rows: this.rowsPerPage
            });
        }
    }
    public driverVehicleTypes: any[] = [];
    public driverServiceTypes: any[] = [];
    private lazyLoadHandled: boolean = true;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    public arrayFilterRiderStatuses: any = [];
    public arrayFilterStatuses: any = [];
    public arrayFilterRegions: any = [];
    public arrayFilterServices: any = [];
    public arrayFilterRatings: any = [];
    public riderSourceType = RiderSourceTypeEnum;
    public riderSourceTypeList = RiderSourceType.RiderSourceTypeList;
    public lastActiveTypeList = LastActiveTypeModel.LastActiveTypeList;

    public backOffice = BackOfficeEnum;

    public riders: Array<any> = [];

    public cols: any[] = [
        { field: 'RiderId', fieldType: FieldTypeEnum.InputNumber, model: 'driverId',
            placeholder: 'Type here', header: 'Driver ID', width: '20%', active: false },
        { field: 'RiderStatusText', fieldType: FieldTypeEnum.Dropdown, options: this.arrayFilterRiderStatuses, model: 'riderStatus',
            placeholder: 'Please Select', header: 'Rider Status', width: '20%', active: false },
        { field: 'UserName', fieldType: FieldTypeEnum.Inputs, model: 'driverName',
            placeholder: 'Type here', header: 'Driver', width: '20%', active: false },
        { field: 'Phone', fieldType: FieldTypeEnum.Inputs, model: 'phone',
            placeholder: 'Type here', header: 'Phone',  width: '20%', active: false },
        { field: 'Email', fieldType: FieldTypeEnum.Inputs, model: 'email',
            placeholder: 'Type here', header: 'Email', width: '20%', active: false },
        { field: 'CreatedAtDate', fieldType: FieldTypeEnum.Calendar, model: 'signupDate',
            placeholder: 'Select Date', header: 'Signup Date', width: '20%', active: false },
        { field: 'Services', fieldType: FieldTypeEnum.Dropdown, options: this.arrayFilterServices, model: 'service',
            placeholder: 'Please Select', header: 'Services', width: '20%', active: false },
        { field: 'LastLogin', fieldType: FieldTypeEnum.Dropdown, options: this.lastActiveTypeList, model: 'lastActiveTypeObj',
            placeholder: 'Please Select', header: 'Last Login', width: '20%', take: 'obj', active: false },
        { field: 'Status', fieldType: FieldTypeEnum.Dropdown, options: this.arrayFilterStatuses, model: 'status',
            placeholder: 'Please Select', header: 'Status', width: '20%', active: false }
    ];
    public defaultCols = this.cols.map(x => x);

    // Grid settings
    public rowsPerPage: number = Utils.getRowsPerPageCount();
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;
    private skip: number = 0;

    public filter: {
        searchName: string;
        startDateJoin: Date | undefined;
        endDateJoin: Date | undefined;
    } = { searchName: '', startDateJoin: undefined, endDateJoin: undefined };

    public driverSignupDate!: Date;

    public selectedDriver: any;


    private refreshTimer: number = 0;
    public loading: boolean = true;

    private searchTimer: number = 0;

    public driverId!: number;
    public visibleFilter: boolean = false;
    public visibleDetail: boolean = false;

    public showEditFields: boolean = false;

    $drivers: Observable<any>;
    $driversSubject: Subscription | undefined;

    public driverHeaderSearch: any = {
        driverId: null,
        driverName: null,
        phone: null,
        email: null,
        signupDate: null,
        region: null,
        service: null,
        rating: null,
        lastActiveTypeObj: null,
        riderSourceType: null,
        status: null,
        riderStatus: null
    };
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Drivers' },
        { label: this.app.backOfficeRoot.getDriverType() },{ label: this.app.backOfficeRoot.getMenuValue() }];

    constructor(
        private messageService: MessageService,
        private riderService: RiderService,
        public configService: ConfigService,
        public app: AppComponent,
        private xpressUserService: XpressUserService,
        private signalRService: SignalrService) {
        this.$drivers = this.signalRService.RidersObservable;
    }

    ngOnInit(): void {
        this.signalRService.startConnection().then(() => {
            console.log('signalR Service connected');
            this.signalRService.addUpdateRidersListener();
            this.$driversSubject = this.$drivers.subscribe((data: any) => {
                this.callBoardingTitles(this.skip);
                console.log('signalR Service: updated draft riders');
            });
        });
    }

    ngOnDestroy(): void {
        this.signalRService?.disconnect();
        this.$driversSubject?.unsubscribe();
    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        this.skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.tableName = this.app.backOfficeRoot.getDriverType() + '-' + this.app.backOfficeRoot.getMenuValue();
        this.loadColumnSelectorSettings();
        this.callBoardingTitles(this.skip);
        this.breadcrumbs = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Drivers' },
            { label: this.app.backOfficeRoot.getDriverType() },{ label: this.app.backOfficeRoot.getMenuValue() }];

        this.lazyLoadHandled = false;
    }

    loadColumnSelectorSettings() {
        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.app.backOfficeRoot.getDriverType() + '-' +
                this.app.backOfficeRoot.getMenuValue());
        }
    }

    onSelectedColumnsChange(event: any) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }

    private callBoardingTitles(skip: number) {
        this.getRiders(skip);
    }

    getRiders(skip: number) {
        this.loading = true;

        const dto = {
            SearchName: this.filter.searchName,
            ServiceTypes: this.driverServiceTypes,
            VehicleTypes: this.driverVehicleTypes,
            RiderId: this.driverHeaderSearch.driverId,
            RiderName: this.driverHeaderSearch.driverName,
            SignupDate: (!this.driverHeaderSearch.signupDate) ? null : moment(this.driverHeaderSearch.signupDate).format('YYYY-MM-DDTHH:mm:ss'),
            LastActiveType: (this.driverHeaderSearch.lastActiveTypeObj) ? this.driverHeaderSearch.lastActiveTypeObj.value : null,
            LastActiveAt: (this.driverHeaderSearch.lastActiveTypeObj && this.driverHeaderSearch.lastActiveTypeObj.dateTime) ?
                moment(this.driverHeaderSearch.lastActiveTypeObj.dateTime).format('YYYY-MM-DDTHH:mm:ss') : null,
            Region: this.driverHeaderSearch.region,
            Service: this.driverHeaderSearch.service,
            LastLogin: this.driverHeaderSearch.lastlogin,
            Status: this.driverHeaderSearch.status,
            Rating: this.driverHeaderSearch.rating,
            RiderSourceType: this.driverHeaderSearch.riderSourceType,
            Phone: this.driverHeaderSearch.phone,
            Email: this.driverHeaderSearch.email,
            RiderStatus: this.driverHeaderSearch.riderStatus,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };

        this.riderService.getDraftRiders(dto, this.messageService)
            .then(data => {
                this.loading = false;

                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;
                this.riders = data.Items;
                this.riders.forEach(item => {
                    item.CreatedAtDate = moment(item.CreatedAt).format('Do MMM YYYY');

                    if (item.Status === 'Active') {
                        item.StatusBackColor = '#E7F7EF';
                        item.StatusColor = '#1CBA70';
                    }
                    else if (item.Status === 'Offline') {
                        item.StatusBackColor = '#FDEBEA';
                        item.StatusColor = '#EB4236';
                    }
                    this.mergeDropdownRiderStatusDuplicates(item.RiderStatusText, this.arrayFilterRiderStatuses, item.RiderStatus);
                    this.mergeDropdownDuplicates(item.Status, this.arrayFilterStatuses, 'name');
                    this.mergeDropdownDuplicates(item.Region, this.arrayFilterRegions, 'name');
                    this.mergeDropdownServiceDuplicates(item.Services, this.arrayFilterServices, 'name');
                    this.mergeDropdownDuplicates(item.Rating, this.arrayFilterRatings, 'name');
                });

            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public mergeDropdownServiceDuplicates(services: any[], array: any[], property: string) {
        for (const service of services) {
            const exists = array.some((obj: any) => obj[property] === service);
            if (!exists) {
                const newObj: any = {};
                newObj[property] = service;
                array.push(newObj);
            }
        }
    }

    public mergeDropdownDuplicates(name: string, array: any[], property: string) {
        const exists = array.some((obj: any) => obj[property] === name);
        if (!exists && name) {
            const newObj: any = {};
            newObj[property] = name;
            array.push(newObj);
        }
    }

    public mergeDropdownRiderStatusDuplicates(name: string, array: any[], value: XpressRiderStatus) {
        const exists = array.some((obj: any) => obj.value === value);
        if (!exists && name) {
            const newObj: any = {};
            newObj.name = name;
            newObj.value = value;
            array.push(newObj);
        }
    }

    public handleHeaderFilterChange(model: string, event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.callBoardingTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public onChangeDateAndDropDown(event: any) {
        this.callBoardingTitles(0);
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getRiders(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public handleShowDriverInfo(driver: any) {
        this.selectedDriver = driver;
        this.visibleDetail = true;
    }

    changedVisibleDetailEmit(value: any) {
        this.visibleDetail = value;
    }

    callBackOfficeForFilter(backOffice: BackOfficeEnum) {
        switch (backOffice) {
            case BackOfficeEnum.Passenger2W:
                this.driverVehicleTypes = [RiderVehicleTypeEnum.Moto];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Ride,
                    ServiceTypeEnum.Hire,
                    ServiceTypeEnum.Transfer,
                    ServiceTypeEnum.ScanAndRide,
                    ServiceTypeEnum.Single,
                    ServiceTypeEnum.Charter];
                break;
            case BackOfficeEnum.Passenger3W:
                this.driverVehicleTypes = [RiderVehicleTypeEnum.ETrike];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Ride,
                    ServiceTypeEnum.Hire,
                    ServiceTypeEnum.Transfer,
                    ServiceTypeEnum.ScanAndRide,
                    ServiceTypeEnum.Single,
                    ServiceTypeEnum.Charter];
                break;
            case BackOfficeEnum.Passenger4W:
                this.driverVehicleTypes = [
                    RiderVehicleTypeEnum.None,
                    RiderVehicleTypeEnum.Sedan,
                    RiderVehicleTypeEnum.SUV,
                    RiderVehicleTypeEnum.Fastest,
                    RiderVehicleTypeEnum.PetTaxi,
                    RiderVehicleTypeEnum.Courier,
                    RiderVehicleTypeEnum.Cargo,
                    RiderVehicleTypeEnum.Van,
                    RiderVehicleTypeEnum.Minibus,
                    RiderVehicleTypeEnum.Multicab
                ];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Ride,
                    ServiceTypeEnum.Hire,
                    ServiceTypeEnum.Transfer,
                    ServiceTypeEnum.ScanAndRide,
                    ServiceTypeEnum.Single,
                    ServiceTypeEnum.Charter];
                break;
            case BackOfficeEnum.Delivery2W:
                this.driverVehicleTypes = [RiderVehicleTypeEnum.Moto];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Delivery,
                    ServiceTypeEnum.Food,
                    ServiceTypeEnum.Grocery];
                break;
            case BackOfficeEnum.Delivery4W:
                this.driverVehicleTypes = [
                    RiderVehicleTypeEnum.None,
                    RiderVehicleTypeEnum.Sedan,
                    RiderVehicleTypeEnum.SUV,
                    RiderVehicleTypeEnum.Fastest,
                    RiderVehicleTypeEnum.PetTaxi,
                    RiderVehicleTypeEnum.Courier,
                    RiderVehicleTypeEnum.Cargo,
                    RiderVehicleTypeEnum.Van,
                    RiderVehicleTypeEnum.Minibus,
                    RiderVehicleTypeEnum.Multicab];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Delivery,
                    ServiceTypeEnum.Food,
                    ServiceTypeEnum.Grocery];
                break;
            default:
                this.driverVehicleTypes = [];
                this.driverServiceTypes = [];
                break;
        }
    }
}
